import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { ROUTE_PATHS } from "@/lib/index";
import Home from "@/pages/Home";
import Legal from "@/pages/Legal";
import Eligibility from "@/pages/Eligibility";
import Announcement from "@/pages/Announcement";
import Progress from "@/pages/Progress";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path={ROUTE_PATHS.HOME} element={<Home />} />
          <Route path={ROUTE_PATHS.LEGAL} element={<Legal />} />
          <Route path={ROUTE_PATHS.ELIGIBILITY} element={<Eligibility />} />
          <Route path={ROUTE_PATHS.ANNOUNCEMENT} element={<Announcement />} />
          <Route path={ROUTE_PATHS.PROGRESS} element={<Progress />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;